import classNames from 'classnames';
import React from 'react';

import { useLibrarySetupContext } from '@/contexts/LibrarySetupContext';
import {
  FILE_STATUS,
  STATUS
} from '@/contexts/LibrarySetupContext/constants';

import Drag from '@/components/common/Dnd/Drag';

import { FOLDER_ITEM_TYPE_SECTION } from '../../constants';
import useFolderItemMetadataProps from '../../hooks/useFolderItemMetadataProps';
import AssetCard from '../AssetCard';
import FolderItemSectionCard from './FolderItem/FolderItemSectionCard';

const FolderItems = (props) => {
  const {
    folderItemsList,
    parentSectionId,
    collapsedSectionsFolderItems,
    toggleSectionAccordion
  } = props;

  const {
    status,
    filesUploadingStatus,
    uploadProgressMap,
    activeCommunity,
    selectedFolder,
    onFolderItemEditClick,
    openDeleteItemModal,
    saveChangesOnFolderItem,
    onAddItemsToFolderList,
    setShowAddContentDiv,
    onFolderItemsDrop,
    folderItemIdsInFocus,
    removeFolderItemFromFocus
    // isSectionBeingDragged
  } = useLibrarySetupContext();

  const { getItemProps, onThumbnailChange } = useFolderItemMetadataProps({
    saveChangesOnFolderItem,
    activeCommunitySlug: activeCommunity?.link,
    selectedFolder,
    openDeleteItemModal
  });

  const isFolderItemsInSection = !!parentSectionId;

  const isUploadingStatus = status === STATUS.UPLOADING;

  // TODO - @aman - remove
  const debug = false;
  // const debug = true;

  const renderSectionTypeItem = (item, draggableProvided) => {
    // isExpanded is true if section id is not present in collapsedSectionsFolderItems
    const isExpanded = !collapsedSectionsFolderItems?.[item?._id];

    return (
      <FolderItemSectionCard
        {...getItemProps(item)}
        folderItem={item}
        draggableProvided={draggableProvided}
        onFolderItemEditClick={onFolderItemEditClick}
        onAddItemsToFolderList={onAddItemsToFolderList}
        setShowAddContentDiv={setShowAddContentDiv}
        onFolderItemsDrop={onFolderItemsDrop}
        isExpanded={isExpanded}
        toggleSectionAccordion={toggleSectionAccordion}
        folderItemIdsInFocus={folderItemIdsInFocus}
        removeFolderItemFromFocus={removeFolderItemFromFocus}
        debug={debug}
      />
    );
  };

  const renderAssetFolderItem = (
    item,
    draggableProvided,
    draggableSnapshot
  ) => {
    const isUploading =
      isUploadingStatus &&
      filesUploadingStatus?.[item?.clientId] === FILE_STATUS.LOADING;

    const progress =
      uploadProgressMap?.[item?.clientId]?.totalProgress ?? 0;
    return (
      <AssetCard
        {...getItemProps(item)}
        key={item.clientId}
        folderItem={item}
        isUploading={isUploading}
        uploadedProgressBar={progress ? progress : false}
        onFolderItemEditClick={onFolderItemEditClick}
        draggableSnapshot={draggableSnapshot}
        draggableProvided={draggableProvided}
        // isDraggingOver={isDraggingOver}
        onDeleteClick={() => openDeleteItemModal(item)}
        onThumbnailChange={onThumbnailChange}
        minified={isFolderItemsInSection}
        debug={debug}
      />
    );
  };

  const renderFolderItem = (
    item,
    draggableProvided,
    draggableSnapshot
  ) => {
    const isSection = item?.type === FOLDER_ITEM_TYPE_SECTION;

    if (isSection) return renderSectionTypeItem(item, draggableProvided);

    return renderAssetFolderItem(
      item,
      draggableProvided,
      draggableSnapshot
    );
  };

  return folderItemsList.map((item, index) => {
    const isUploading =
      isUploadingStatus &&
      filesUploadingStatus?.[item?.clientId] === FILE_STATUS.LOADING;
    return (
      <Drag
        key={item.clientId.toString()}
        id={item.clientId.toString()}
        index={index}
        className={classNames('folder-item-card-container relative', {
          'opacity-50': isUploading
        })}>
        {(provided, snapshot) =>
          renderFolderItem(item, provided, snapshot)
        }
      </Drag>
    );
  });
};

// export default FolderItems;
export default React.memo(FolderItems);
